import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { HttpResponse } from '@angular/common/http';
import { ProjectTaskService } from 'src/app/_services/project_task/project-task.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TaskService } from 'src/app/_services/task/task.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project/project.service';

@Component({
  selector: 'app-partlist',
  templateUrl: './partlist.component.html',
  styleUrls: ['./partlist.component.scss']
})
export class PartlistComponent implements OnInit {

  tenantId: string;
  userDetails: any;
  currentProjectId: any;
  isAdministrator: boolean = false;
  isPMOAdmin: boolean = false;
  isPMOLeadORManager: boolean = false;
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  private api: GridApi;    // gridApi and columnApi  
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any;
  rowData: any;
  sampleGridFrameworkComponents: any;
  form: FormGroup;
  selectedFile: File;
  fileName: any;

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private projecttaskService: ProjectTaskService,
    private snackBar: MatSnackBar,
    private taskService: TaskService,
    private route: ActivatedRoute,
    private router: Router,
    private projectService: ProjectService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    // this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.userDetails.roles.includes('RolePmoAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.getProjectByIdV2(this.currentProjectId);
    this.getPartList();
  }

  getProjectByIdV2(id) {
    this.projectService.getProjectV2(id).subscribe((response: any) => {
      if (response) {
        if(response.projectManagerId === this.userDetails.id || response.projectLeadId === this.userDetails.id){
          this.isPMOLeadORManager = true;
        }
      }
    }, error => {
      this.openSnackBar('ERROR: cannot get project by id: ' + error);
    })
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    // console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: 'Part List',
        field: 'partList',
        filter: true,
        editable: false,
        sortable: true,
      },
    ]
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  public onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  importPartList() {
    const partList = new FormData();
    partList.append('file', this.selectedFile);
    this.projecttaskService.importPartList(this.currentProjectId, partList).subscribe({
      next: () => {
        this.openSnackBar('File Imported Successfully!!');
        this.getPartList();
      },
      error: (err) => {
        console.error(err);
        this.openSnackBar('File Import Failed');
      }
    });
  }

  exportPartList() {
    this.projecttaskService.exportPartList(this.currentProjectId).subscribe(
      (response: HttpResponse<Blob>) => {
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        downloadLink.setAttribute('download', 'partList.csv');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      (error) => {
      }
    );
  }

  getPartList() {
    this.projecttaskService.getPartList(this.currentProjectId).subscribe((response: any) => {
      if (response) {
        this.rowData = response;
      }
    });
  }

  backToMyProjectV2() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
  }

}